var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAngleLeft = function SvgAngleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "#09205D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.55 10.277a1.25 1.25 0 0 0-1.767 0l-8.839 8.84a1.25 1.25 0 0 0 0 1.767l8.84 8.839a1.25 1.25 0 0 0 1.767-1.768L17.596 20l7.955-7.955a1.25 1.25 0 0 0 0-1.768Z"
  })));
};

export default SvgAngleLeft;